import { render } from "./DescriptionField.vue?vue&type=template&id=754c8dd0"
import script from "./DescriptionField.vue?vue&type=script&lang=js"
export * from "./DescriptionField.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__